var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',{directives:[{name:"show",rawName:"v-show",value:(_vm.render),expression:"render"}]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }